import { ReactComponent } from "/builds/mb/front/src/app/assets/images/marker.svg?react";
import url from "/builds/mb/front/src/app/assets/images/marker.svg?url";
export { ReactComponent };
export default url;
